export default class FormLiteDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { modifiedDate: json.modifiedDate && new Date(json.modifiedDate), createdDate: json.createdDate && new Date(json.createdDate) });
    }
}
